var map = {
	"./COMPACT.png": 97783,
	"./EN-Funded_by_the_EU-BLACK.png": 23759,
	"./EN-Funded_by_the_EU-PANTONE.png": 72375,
	"./LOGO_TYPE.png": 84800,
	"./background_recharge_pink.png": 44229,
	"./linkedin-logo.svg": 15013,
	"./platoniq-logo.png": 45446
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71027;